import { boolean, defineAction, object } from '~/prix'
import systemImportSebraeNaSuaEmpresaAction from './systemImportSebraeNaSuaEmpresa.action.json' with { type: 'json' }

const systemImportSebraeNaSuaEmpresaDefinition = defineAction({
  ...systemImportSebraeNaSuaEmpresaAction,
  input: object({
    forceRecreation: boolean(),
  }),
  output: object({}),
})

export default systemImportSebraeNaSuaEmpresaDefinition
